import React, { Component } from 'react';
import './App.css';
import Survey from './components/Survey';
import bg from './design.svg';

class App extends Component {
  render() {
    return (
      <div className='App'>
        <img src={bg} alt='background design' className='bg' />
        <h1 className='text-center heading'>Questionare</h1>
        <hr />
        <Survey />
      </div>
    );
  }
}

export default App;
